import { client } from './client';

const API_ENDPOINT = process.env.REACT_APP_MS_FINAL_CUSTOMER_IMPORTS;

class ImportDataService {
  static sendFile(path = '', file) {
    const formData = new FormData();
    formData.append('data', file);
    return client({
      method: 'POST',
      url: path,
      baseURL: API_ENDPOINT,
      data: formData,
      headers: { 'Content-Type': undefined },
    });
  }
}

export { ImportDataService };
